<template>
  <div class="table">
    <div class="container">
      <!--=========查询模块================-->
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('base.pp.pickupPoint')" prop="pickupPoint">
                <el-input class="handle-input" v-model="queryCondition.pickupPoint"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('common.status')" prop="status">
                <el-select v-model="queryCondition.status" :disabled="disabledStatusFlag">
                  <el-option :label="$t('common.all')" value=""></el-option>
                  <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row type="flex" justify="center">
            <el-button size="mini" type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
            <el-button size="mini" type="primary" @click="restQueryForm()">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <!--=========查询模块END================-->
      <el-row class="action-btn-row">
        <el-button size="mini" type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      </el-row>
      <!--=========数据列表================-->
      <el-table sortable max-height="400" :data="pickupPointList" ref="pickupPointDataTable" border highlight-current-row class="table">
        <el-table-column align="center" prop="tmPickupPointId" width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmPickupPointId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="pickupPoint" :label="$t('base.pp.pickupPoint')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="name" :label="$t('common.updateBy')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="updateDate" :label="$t('common.updateDate')">
          <template slot-scope="scope">
            {{scope.row.updateDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="statusI18n" :label="$t('common.status')"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========数据列表END================-->

  </div>
</template>
<script>
import { pickupPointService } from "../../../api/base-data/pickup-point";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils"
export default {
  name: 'pickup-point-sel',
  data() {
    return {
      totalCount: 0,
      pickupPointList: [],
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        pickupPoint: "",
        status: "1"
      },
      radioVal: -99,
      selectPickupPoint: null,
      disabledStatusFlag: true,
      statusList: [],
    }
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      pickupPointService.getPickupPointData(this.queryCondition).then((res) => {
        this.pickupPointList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    restQueryForm() {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.selectPickupPoint = null
      this.radioVal = ""
      this.queryData()
    },
    getTemplateRow: function (row) {
      this.selectPickupPoint = row;
    },
    clickSelectMethod: function () {
      if (this.selectPickupPoint == null) {
        this.$message({ message: "请选择提货点", type: "warning" });
      } else {
        this.$emit('subCallMethod', this.selectPickupPoint);
        this.restQueryForm()

      }
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:STATUS_DISABLE_ENABLE"] = "COMMON:STATUS_DISABLE_ENABLE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.statusList = res["COMMON:STATUS_DISABLE_ENABLE"];
      });
    },
    cancelSeleted: function () {
      this.radioVal = null;
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.handle-input {
  width: 95%;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
